import type {
	AnnotationPluginOptions,
	InlineCommentAnnotationProvider,
} from '@atlaskit/editor-plugin-annotation';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options:
		| Pick<
				AnnotationPluginOptions,
				| 'createCommentExperience'
				| 'selectCommentExperience'
				| 'inlineComment'
				| 'annotationManager'
		  >
		| undefined;
	providers: {
		inlineCommentAnnotationProvider: InlineCommentAnnotationProvider | undefined;
	};
}

export function annotationPluginOptions({
	options,
	providers,
}: Props): AnnotationPluginOptions | undefined {
	return providers.inlineCommentAnnotationProvider
		? {
				createCommentExperience: options?.createCommentExperience,
				inlineComment: providers.inlineCommentAnnotationProvider,
				selectCommentExperience: options?.selectCommentExperience,
				annotationManager: fg('platform_editor_comments_api_manager')
					? options?.annotationManager
					: undefined,
			}
		: undefined;
}
